import React from 'react';
import '../../pages/pages.css';
import servicesImg from './serviceImg.png';

function Services() {
  return (
    <div className="page-container">
      <div className="page-image">
        <img src={servicesImg} />
      </div>
      <div className="page-text">
      <h1>Services</h1>
        <p>
          To introduce new AV collaboration techniques using hardware and software with AI touch, offering a comprehensive range of services, including:
        </p>
        <ul>
          <li>Audio-Video Consulting</li>
          <li>Audio-Video Consulting</li>
          <li>Audio-Video Integration</li>
          <li>Project Management</li>
          <li>Design Support</li>
          <li>Inhouse and Virtual Trainings</li>
          <li>Personal and Group Collaboration Gadgets</li>
          <li>Managed Services</li>
        </ul>
      </div>
    </div>
  );
}

export default Services;